import { WorkingDays } from "../WorkingDays";

export const WorkingDaysLabels = {
  [WorkingDays.Monday]: "Monday",
  [WorkingDays.Tuesday]: "Tuesday",
  [WorkingDays.Wednesday]: "Wednesday",
  [WorkingDays.Thursday]: "Thursday",
  [WorkingDays.Friday]: "Friday",
} as const;
